import PropTypes from 'prop-types';
import React from 'react';
import PhaseType from 'types/phase';

export const check_in_measurement = ({ event: { kind } }) =>
  <div className={kind}>
    Information has been checked in from Floor Wizard.
  </div>;

check_in_measurement.propTypes = {
  event: PropTypes.shape({
    kind: PropTypes.string.isRequired,
  }).isRequired,
  phase: PhaseType,
};



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEvents/check_in_measurement.jsx